const MovieSkeleton = ({ isRow = false }) => {
    if (isRow) {
        return (
            <div className="flex items-start gap-3 bg-white pb-3 animate-pulse">
                <div className="w-20 h-28 bg-gray-200 rounded-lg"></div>
                <div className="flex-1">
                    <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                    <div className="space-y-2">
                        <div className="h-3 bg-gray-200 rounded w-full"></div>
                        <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                        <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="relative bg-white shadow-lg overflow-hidden rounded-lg animate-pulse">
            <div className="w-full h-40 bg-gray-200"></div>
            <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-gray-200 via-gray-200/60 to-transparent p-2">
                <div className="h-3 bg-gray-300 rounded w-3/4 mb-2"></div>
                <div className="h-3 bg-gray-300 rounded w-1/2"></div>
            </div>
        </div>
    );
};

export default MovieSkeleton; 